import React from "react";
import classNames from "classnames";
import { Icon } from "semantic-ui-react";

const ProfileOrganisation = ({
  name,
  position,
  isPrimary,
  disabled,
  children,
}) => (
  <div className={classNames("profile-organisation", { disabled })}>
    {isPrimary && <Icon className="primary star icon" />}
    <span className="name">{name}</span>
    {name && position && <span style={{ padding: "0 0.25em" }}>&middot;</span>}
    {position && <span className="position">{position}</span>}
    {children}
  </div>
);

export default ProfileOrganisation;
